import LegalLayout from "./LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout title="Politique sur les cookies" updated="23 juillet 2026">
      <p>
        Chez <strong>Délices Mikaté Royal</strong>, nous utilisons des cookies afin d&apos;assurer le bon
        fonctionnement de notre site, d&apos;améliorer votre expérience de navigation et de mieux
        comprendre l&apos;utilisation de notre site.
      </p>
      <p>
        Cette politique explique ce que sont les cookies, comment nous les utilisons et comment vous
        pouvez gérer vos préférences.
      </p>

      <h2>1. Qu&apos;est-ce qu&apos;un cookie&nbsp;?</h2>
      <p>
        Un cookie est un petit fichier texte enregistré sur votre appareil lorsque vous visitez un site
        Web.
      </p>
      <p>
        Les cookies permettent notamment de mémoriser certaines préférences, d&apos;assurer la sécurité
        du site et d&apos;améliorer l&apos;expérience des visiteurs.
      </p>

      <h2>2. Cookies strictement nécessaires</h2>
      <p>Ces cookies sont indispensables au fonctionnement du site.</p>
      <p>Ils permettent notamment&nbsp;:</p>
      <ul>
        <li>d&apos;assurer la sécurité du site&nbsp;;</li>
        <li>de permettre la navigation&nbsp;;</li>
        <li>de mémoriser certaines préférences&nbsp;;</li>
        <li>d&apos;assurer le bon fonctionnement des fonctionnalités essentielles.</li>
      </ul>
      <p>
        Ces cookies ne nécessitent pas de consentement puisqu&apos;ils sont nécessaires au fonctionnement
        du site.
      </p>

      <h2>3. Cookies de mesure d&apos;audience – PostHog</h2>
      <p>
        Délices Mikaté Royal utilise l&apos;outil de mesure d&apos;audience <strong>PostHog</strong> afin
        de mieux comprendre comment les visiteurs utilisent notre site et d&apos;améliorer nos services.
      </p>
      <p>Ces données nous permettent notamment d&apos;analyser&nbsp;:</p>
      <ul>
        <li>les pages consultées&nbsp;;</li>
        <li>l&apos;utilisation générale du site&nbsp;;</li>
        <li>les améliorations possibles de l&apos;expérience utilisateur.</li>
      </ul>
      <p>Aucune donnée personnelle n&apos;est vendue à des tiers.</p>
      <p>
        Le suivi analytique est activé uniquement lorsque le visiteur donne son consentement par
        l&apos;intermédiaire de la bannière de cookies.
      </p>

      <h2>4. Gestion de vos préférences</h2>
      <p>Lors de votre première visite, une bannière de consentement vous permet de choisir&nbsp;:</p>
      <ul>
        <li><strong>Tout accepter</strong>&nbsp;: autoriser les cookies non essentiels&nbsp;;</li>
        <li><strong>Tout refuser</strong>&nbsp;: désactiver les cookies non essentiels&nbsp;;</li>
        <li><strong>Enregistrer mes préférences</strong>&nbsp;: personnaliser vos choix.</li>
      </ul>
      <p>Vous pouvez modifier vos préférences à tout moment.</p>

      <h2>5. Désactivation des cookies</h2>
      <p>
        Vous pouvez également gérer ou supprimer les cookies dans les paramètres de votre navigateur.
      </p>
      <p>
        La désactivation de certains cookies peut toutefois affecter le fonctionnement de certaines
        fonctionnalités du site.
      </p>

      <h2>6. Protection des renseignements personnels</h2>
      <p>
        Les renseignements recueillis par l&apos;intermédiaire des cookies sont traités conformément à
        notre&nbsp;:
      </p>
      <p>
        <a href="/politique-confidentialite">Politique de confidentialité</a>
      </p>

      <h2>7. Contact</h2>
      <p>Pour toute question concernant l&apos;utilisation des cookies&nbsp;:</p>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
